export default function wordDeclension(num, declensions) {
  const cases = [2, 0, 1, 1, 1, 2];
  if (num % 100 > 4 && num % 100 < 20) {
    return declensions[2];
  }
  return declensions[cases[num % 10 < 5 ? num % 10 : 5]];
}
